module.exports = __webpack_public_path__ + "media/images/bnr_header_newplan_sp-de56faa550f3fe9f2c9fb047de3f3bac.jpg";